export { THead } from "./THead";
